<template>
  <a-modal
    title="新建"
    :width="1080"
    :visible="visible"
    :maskClosable="false"
    :confirmLoading="loading"
    @ok="this.ok"
    @cancel="() => { $emit('cancel') }"
  >
    <a-spin :spinning="loading">
      <a-form :form="form" :layout="formLayout">
        <a-row>
          <a-col :span="24">
            <a-divider orientation="left">
              关联信息
            </a-divider>
          </a-col>
          <a-col :span="12">
            <a-form-item label="采销全流程" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-select
                :show-arrow="false"
                :filter-option="false"
                :not-found-content="projectFetching ? undefined : null"
                show-search
                v-decorator="[
                  'project_id',
                  {
                    rules: [
                      { required: true, message: '请选择' },
                    ],
                  },
                ]"
                placeholder="请输入名称"
                @search="this.projectSearch"
                @change="handleProjectChange"
              >
                <a-spin v-if="projectFetching" slot="notFoundContent" size="small" />
                <a-select-option v-for="d in projectList" :key="d.id">
                  {{ d.name }}（{{ d.number }}）
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="购销合同" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-select
                v-decorator="[
                  'sell_contract_id',
                  {
                    rules: [
                      { required: true, message: '请选择' }
                    ],
                  },
                ]"
                placeholder="请选择"
                show-search
                :not-found-content="contractFetching ? undefined : null"
                option-filter-prop="children"
                :filter-option="filterOption"
              >
                <a-spin v-if="contractFetching" slot="notFoundContent" size="small" />
                <a-select-option :key="key" :value="val.id" v-for="(val, key) in sellContractList">{{ val.name }}（{{ val.number }}）</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-divider orientation="left">
              提单/运单信息
            </a-divider>
          </a-col>
          <a-col :span="12">
            <a-form-item label="编号" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input v-decorator="['number', {rules: [{required: true, message: '必填项，请填写信息'}, {max:32, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="提单/运单号" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input v-decorator="['bill_of_lading_number', {rules: [{required: true, message: '必填项，请填写信息'}, {max:32, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="提单签发日期" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-date-picker
                style="width: 100%"
                v-decorator="['bill_of_lading_date', {rules: [{required: true, message: '必填项，请填写信息'}]}]"
                format="YYYY-MM-DD"
                placeholder="请选择"
                value-format="yyyy-MM-DD"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="发货人" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input v-decorator="['shipper', {rules: [{required: true, message: '必填项，请填写信息'}, {max:100, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="承运人" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input v-decorator="['carrier', {rules: [{required: true, message: '必填项，请填写信息'}, {max:100, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="收货人" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input v-decorator="['consignee', {rules: [{required: true, message: '必填项，请填写信息'}, {max:100, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="通知方" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input v-decorator="['notify_party', {rules: [{required: false, message: '必填项，请填写信息'}, {max:100, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="装货港" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input v-decorator="['loading_port', {rules: [{required: false, message: '必填项，请填写信息'}, {max:256, message: '输入超出长度限制'}]}]" allow-clear placeholder="交货地" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="卸货港" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input v-decorator="['discharge_port', {rules: [{required: false, message: '必填项，请填写信息'}, {max:256, message: '输入超出长度限制'}]}]" allow-clear placeholder="交货地" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="货物扩展分类" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-select
                v-decorator="[
                  'cargo_category',
                  {
                    rules: [
                      { required: true, message: '请选择' }
                    ],
                  },
                ]"
                placeholder="请选择"
                allow-clear
                option-filter-prop="children"
                @change="cargoCategoryChange"
                :filter-option="filterOption">
                <a-select-option :key="key" :value="key" v-for="(val, key) in this.$Dictionaries.trade_lading_bill_type">{{ val }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="24" v-if="selectedCargoCategory">
            <a-divider orientation="left">
              {{ selectedCargoCategory }}
            </a-divider>
          </a-col>
          <a-col :span="12" v-if="selectedCargoCategoryIndex === '1'">
            <a-form-item label="罐号" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input v-decorator="['tank_number', {rules: [{required: true, message: '必填项，请填写信息'}, {max:32, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="selectedCargoCategoryIndex === '1'">
            <a-form-item label="入罐日期" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-date-picker
                style="width: 100%"
                v-decorator="['intake_date', {rules: [{required: true, message: '必填项，请填写信息'}]}]"
                format="YYYY-MM-DD"
                placeholder="请选择"
                value-format="yyyy-MM-DD"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="selectedCargoCategoryIndex === '2'">
            <a-form-item label="卸货日期" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-date-picker
                style="width: 100%"
                v-decorator="['discharge_date', {rules: [{required: true, message: '必填项，请填写信息'}]}]"
                format="YYYY-MM-DD"
                placeholder="请选择"
                value-format="yyyy-MM-DD"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="selectedCargoCategoryIndex === '3'">
            <a-form-item label="铅封号" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input v-decorator="['seal_number', {rules: [{required: true, message: '必填项，请填写信息'}, {max:100, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="selectedCargoCategoryIndex === '3'">
            <a-form-item label="箱型" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-select
                v-decorator="[
                  'container_type',
                  {
                    rules: [
                      { required: true, message: '请选择' }
                    ],
                  },
                ]"
                placeholder="请选择"
                allow-clear
                option-filter-prop="children"
                :filter-option="filterOption">
                <a-select-option :key="key" :value="val" v-for="(val, key) in this.$Dictionaries.trade_container_type">{{ val }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="selectedCargoCategoryIndex === '3'">
            <a-form-item label="箱量" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input-number :precision="4" style="width: 50%" v-decorator="['container_count', {rules: [{required: false, message: '必填项，请填写信息'}]}]" allow-clear placeholder="请输入" />
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="selectedCargoCategoryIndex === '1'">
            <a-form-item label="对应存量" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input-number :precision="4" style="width: 50%" v-decorator="['tank_inventory', {rules: [{required: false, message: '必填项，请填写信息'}]}]" allow-clear placeholder="请输入" />
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="selectedCargoCategoryIndex === '1'">
            <a-form-item label="岸罐数量" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input-number :precision="4" style="width: 50%" v-decorator="['shore_tank_qty', {rules: [{required: false, message: '必填项，请填写信息'}]}]" allow-clear placeholder="请输入" />
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="selectedCargoCategoryIndex !== undefined">
            <a-form-item label="毛重" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input-number :precision="4" style="width: 50%" v-decorator="['gross_weight', {rules: [{required: false, message: '必填项，请填写信息'}]}]" allow-clear placeholder="请输入" />
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="selectedCargoCategoryIndex !== undefined">
            <a-form-item label="净重" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input-number :precision="4" style="width: 50%" v-decorator="['net_weight', {rules: [{required: false, message: '必填项，请填写信息'}]}]" allow-clear placeholder="请输入" />
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="selectedCargoCategoryIndex !== undefined">
            <a-form-item label="单位" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-select
                v-decorator="[
                  'unit',
                  {
                    rules: [
                      { required: false, message: '请选择' }
                    ],
                  },
                ]"
                placeholder="请选择"
                show-search
                option-filter-prop="children"
                :filter-option="filterOption"
              >
                <a-select-option :key="key" :value="key" v-for="(val, key) in this.$Dictionaries.unit">{{ val }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="24" v-if="selectedCargoCategoryIndex !== undefined">
            <a-divider orientation="left">
              {{ selectedCargoCategory }}对应凭证
            </a-divider>
          </a-col>
          <a-col :span="24" v-if="selectedCargoCategoryIndex !== undefined">
            <a-form-item label="附件" :label-col="buttonItemLayout.labelCol" :wrapper-col="buttonItemLayout.wrapperCol">
              <a-button icon="plus" @click="handleAddAttachment">新建</a-button>
              <a-table
                bordered
                :data-source="otherData.attachment"
                :columns="attachmentColumns"
                v-if="this.otherData.attachment.length > 0"
                :pagination="false"
                key="key">
                <template slot="action" slot-scope="text, record">
                  <a-popconfirm
                    v-if="otherData.attachment.length"
                    title="确定删除?"
                    @confirm="() => onAttachmentDelete(record.key)"
                  >
                    <a href="javascript:;">删除</a>
                  </a-popconfirm>
                </template>
              </a-table>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
      <attachment-create-form
        ref="attachmentCreateForm"
        @cancel="handleAddCancel"
        @ok="handleOk"
        :record="mdl"
        :visible="visibleFrom"
        v-if="visibleFrom"
        :loading="confirmLoadingFrom"
        :model="mdl" />
    </a-spin>
  </a-modal>
</template>

<script>
import pick from 'lodash.pick'
import AttachmentCreateForm from '../attachment/modules/CreateForm'
import { sell_contract_list } from '@/api/trade_sell_contract'
import debounce from 'lodash/debounce'
import { project_list } from '@/api/trade_project'

// 表单字段
const fields = ['id', 'host_corporation_id', 'category_id', 'number', 'name', 'credit', 'cash']
export default {
  components: {
    AttachmentCreateForm
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: () => false
    },
    model: {
      type: Object,
      default: () => null
    }
  },
  data () {
    this.projectSearch = debounce(this.handleProjectSearch, 800)
    return {
      formLayout: 'horizontal',
      sellContractList: [],
      otherData: {
        attachment: []
      },
      form: this.$form.createForm(this),
      visibleFrom: false,
      confirmLoadingFrom: false,
      projectFetching: false,
      contractFetching: false,
      projectList: [],
      selectedProjectId: undefined,
      selectedProject: undefined,
      selectedCargoCategory: undefined,
      selectedCargoCategoryIndex: undefined,
      mdl: {},
      attachmentColumns: [
        {
          title: '名称',
          dataIndex: 'name'
        },
        {
          title: '附件',
          dataIndex: 'url'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '150px',
          scopedSlots: { customRender: 'action' }
        }
      ]
    }
  },
  created () {
    console.log('custom modal created', this.form)
    // 防止表单未注册
    fields.forEach(v => this.form.getFieldDecorator(v))
    this.model && this.form.setFieldsValue(pick(this.model, fields))
  },
  computed: {
    formItemLayout () {
      const { formLayout } = this
      return formLayout === 'horizontal'
        ? {
          labelCol: { span: 6 },
          wrapperCol: { span: 18 }
        } : {}
    },
    buttonItemLayout () {
      const { formLayout } = this
      return formLayout === 'horizontal'
        ? {
          labelCol: { span: 4 },
          wrapperCol: { span: 20 }
        } : {}
    }
  },
  methods: {
    handleSellContractSearch () {
      this.contractFetching = true
      this.sellContractList = []
      sell_contract_list({ project_id: this.selectedProjectId, is_expired: false, page: 1, page_size: 999 }).then((res) => {
        const result = res.data.entries || []
        this.sellContractList = result.reduce((acc, current) => {
          if (!acc.some(item => item.number === current.number)) {
            acc.push(current)
          }
          return acc
        }, [])
      }).finally(() => {
        this.contractFetching = false
      })
    },
    handleProjectSearch (value) {
      this.projectFetching = true
      this.projectList = []
      project_list({ name: value }).then((res) => {
        const result = res.data.entries || []
        this.projectList = result
      }).finally(() => {
        this.projectFetching = false
      })
    },
    handleProjectChange (value) {
      if (value !== undefined) {
        this.selectedProjectId = value
        this.selectedProject = this.projectList.filter(item => item.id === this.selectedProjectId)[0]
        this.sellContractList = []
        this.form.setFieldsValue({
          sell_contract_id: undefined
        })
        this.handleSellContractSearch()
      }
    },
    handleAddAttachment () {
      this.visibleFrom = true
    },
    cargoCategoryChange (value) {
      if (this.selectedCargoCategoryIndex !== value) {
        if (this.selectedCargoCategoryIndex === '1') {
          this.form.setFieldsValue({ tank_number: undefined })
          this.form.setFieldsValue({ tank_inventory: undefined })
          this.form.setFieldsValue({ shore_tank_qty: undefined })
          this.form.setFieldsValue({ intake_date: undefined })
        } else if (this.selectedCargoCategoryIndex === '2') {
          this.form.setFieldsValue({ discharge_date: undefined })
        } else if (this.selectedCargoCategoryIndex === '3') {
          this.form.setFieldsValue({ container_type: undefined })
          this.form.setFieldsValue({ container_count: undefined })
          this.form.setFieldsValue({ seal_number: undefined })
        }
        this.form.setFieldsValue({ gross_weight: undefined })
        this.form.setFieldsValue({ net_weight: undefined })
        this.form.setFieldsValue({ unit: undefined })
        this.otherData.attachment = []
      }
      this.selectedCargoCategoryIndex = value
      this.selectedCargoCategory = this.$Dictionaries.trade_lading_bill_type[value]
    },
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    onAttachmentDelete (key) {
      const dataSource = [...this.otherData.attachment]
      this.otherData.attachment = dataSource.filter(item => item.key !== key)
    },
    handleAddCancel () {
      this.visibleFrom = false
      const form = this.$refs.attachmentCreateForm.form
      form.resetFields() // 清理表单数据（可不做）
    },
    handleOk () {
      const form = this.$refs.attachmentCreateForm.form
      form.validateFields((errors, values) => {
        if (!errors) {
          console.log('values', values)
          // 新增
          values.url = values.url.fileList[0].url
          const current_date = new Date()
          values.key = current_date.getHours() + '' + current_date.getMinutes() + '' + current_date.getSeconds()
          this.otherData.attachment.push(values)
          this.visibleFrom = false
          form.resetFields()
        }
      })
    },
    ok () {
      if (this.otherData.attachment) {
        this.otherData.attachment = this.otherData.attachment.map(item => {
          item.key = undefined
          return item
        })
      }
      this.$emit('ok', this.otherData)
    }
  }
}
</script>
